import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';
import { useStoreFinderContext, Util, Components, Hooks } from '@grandvisionhq/stores-v2';
import { fromStoreToStoreResult } from '../../../pages/BookAppointment/adapters/from-store-to-store-result.js';
import { useAppointmentContext } from '../../../pages/BookAppointment/context/AppointmentContext.js';
import { useRoutingContext } from '../../../pages/BookAppointment/context/RoutingContext/context.js';

const { StoreFinderClickableItem , StoreFinderItem  } = Components;
const { useFormattedDistance  } = Hooks;
const StoreFinderItemContainer = (_param)=>{
    var { store , variant , onClick , icon  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "store",
        "variant",
        "onClick",
        "icon"
    ]);
    const { locale  } = useIntl();
    const { setHoveredStore  } = useStoreFinderContext();
    const [{ setStore  }] = useAppointmentContext();
    const [{ goTo  }, { queryParams  }] = useRoutingContext();
    const { isMultilingualEnabled , featureConfigs  } = useFeatureToggles();
    const { appointmentBookingUrlPaddedLength , appointmentBookingAlternativeUrl , appointmentBookingAlternativeUrlStores ,  } = featureConfigs;
    const formattedDistance = useFormattedDistance(store === null || store === void 0 ? void 0 : store.distance);
    const onMouseEnterHandler = React.useCallback(()=>{
        if (variant === 'map-item') {
            return;
        }
        if (!store) {
            return;
        }
        setHoveredStore(fromStoreToStoreResult(store));
    }, [
        setHoveredStore,
        store,
        variant
    ]);
    const onMouseLeaveHandler = React.useCallback(()=>{
        if (variant === 'map-item') {
            return;
        }
        setHoveredStore(null);
    }, [
        setHoveredStore,
        variant
    ]);
    const onClickHandler = React.useCallback(()=>{
        if (!store) {
            return;
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(store);
        const invalidUrl = '##invalid_url##' // If no alternative url can be generated, this will be used in the result
        ;
        const alternativeLocation = Util.getBookAppointmentUrl(invalidUrl, {
            paddedLength: appointmentBookingUrlPaddedLength,
            alternativeUrl: appointmentBookingAlternativeUrl && isMultilingualEnabled ? appointmentBookingAlternativeUrl[locale] : appointmentBookingAlternativeUrl,
            alternativeUrlStores: appointmentBookingAlternativeUrlStores
        })(store);
        if (!alternativeLocation.includes(invalidUrl)) {
            // A valid alternative location was generated
            window.location.assign(alternativeLocation);
            return;
        }
        setStore(store);
        const { typeId , search , userLocation , linkedAppointmentTypeId  } = queryParams;
        const nextStep = typeId ? 'when' : 'what';
        goTo(nextStep, {
            linkedAppointmentTypeId,
            typeId,
            storeId: `${store.code}`,
            search,
            userLocation
        });
    }, [
        onClick,
        setStore,
        store,
        goTo,
        queryParams,
        appointmentBookingUrlPaddedLength,
        isMultilingualEnabled,
        locale,
        appointmentBookingAlternativeUrl,
        appointmentBookingAlternativeUrlStores, 
    ]);
    if (!store) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(StoreFinderClickableItem, swcHelpers.extends({}, rest, {
        icon: icon,
        variant: variant,
        onClick: onClickHandler,
        onMouseEnter: onMouseEnterHandler,
        onMouseLeave: onMouseLeaveHandler
    }), /*#__PURE__*/ React.createElement(StoreFinderItem, {
        view: variant === 'map-item' ? 'map' : 'list',
        store: fromStoreToStoreResult(store),
        showAttributesAs: "tags",
        showEmailAddress: false,
        showPhone: false,
        showOpeningHours: false,
        addressSize: "MINIMAL",
        distance: formattedDistance
    }));
};

export { StoreFinderItemContainer as default };
//# sourceMappingURL=StoreFinderItemContainer.js.map
